import React, { FC } from 'react';
import ChallengeCheckoutBookingTimify from 'src/components/experienceCheckout/ChallengeCheckoutBookingTimify';

import {
  IChallengeCheckoutBookingTimify,
  IChallengeResourceRender,
} from 'src/shared/models';

interface OwnProps extends IChallengeResourceRender {
  config: IChallengeCheckoutBookingTimify;
}

const ChallengeCheckoutTimify: FC<OwnProps> = ({
  config,
  updateChallenge,
  updateUserPoints,
}) => {
  const { isCompleted } = config;

  return (
    <>
      {!isCompleted && (
        <ChallengeCheckoutBookingTimify
          {...{
            config: config,
            updateUserPoints,
            updateChallenge,
          }}
        />
      )}
    </>
  );
};

export default ChallengeCheckoutTimify;
